import { createReducer, on } from '@ngrx/store';
import {
  loadParticipations,
  loadParticipationsSuccess,
  loadParticipationsFailure,
  addParticipation,
  resetParticipations
} from './participations.action';
import { Participation } from 'src/app/models/participation.model';

export interface ParticipationState {
  participations: Participation[];
  loading: boolean;
  error: string | null;
}

const initialState: ParticipationState = {
  participations: [],
  loading: false,
  error: null
};

export const participationsReducer = createReducer(
  initialState,
  on(loadParticipations, state => ({ ...state, loading: true })),
  on(loadParticipationsSuccess, (state, { participations }) => ({
    ...state,
    participations,
    loading: false
  })),
  on(loadParticipationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(addParticipation, (state, { participation }) => ({
    ...state,
    participations: [...state.participations, participation]
  })),
  on(resetParticipations, state => ({
    ...state,
    participations: [],
    loading: false,
    error: null
  }))
);
